export class Config {
    public endpoint?: string = 'https://account.kemnaker.go.id';
    public clientId?: string;
    public clientSecret?: string;
    public scopes?: string = 'basic email';
    public responseType?: 'token' | 'code' = 'token';

    public constructor(data?: Partial<Config>) {
        Object.assign(this, data);
    }
}
